import script from "./VueloManualModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VueloManualModal.vue?vue&type=script&setup=true&lang=js"

import "./VueloManualModal.vue?vue&type=style&index=0&id=02ab2aae&lang=css"

const __exports__ = script;

export default __exports__